// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.onboard-overview {
    color: #203562;
}

.onboard-overview .agent-summary {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* color: #152C5B; */
    padding-top: 30px;
    padding-bottom: 10px;
    border-radius: 8px;
}

.onboard-overview .agent-summary h1 {
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 10px;
}

.onboard-overview .agent-summary p {
    font-size: 16px;
    font-weight: 600;
}

.onboard-overview .total {
    background-color: #E8F2FF;
    border: 2px solid #5478A3;
}

.onboard-overview .active-agent {
    background-color: #F5F5F5;
    border: 2px solid #01C6B8;
}

.onboard-overview .inactive-agent {
    background-color: #F5F5F5;
    border: 2px solid #0F344A;
}

.onboard-overview .invalid-wallet {
    background-color: #F5F5F5;
    border: 2px solid #7E7E7E;
}

.onboard-overview .not-in-use {
    background-color: #7B16040D;
    border: 2px solid #7B1603;
}

.onboard-overview .chart-representation {
    background-color: #FCFCFC;
    padding: 10px;
}

.onboard-overview .activity-chart {
    display: flex;
}

.onboard-overview .header h2, .suspected-wallet h2 {
    font-size: 14px;
    font-weight: 100;
    margin-top: 8px;
}

.onboard-overview select {
    margin-left: auto;
    background-color: #F2F2F2;
    border-radius: 8px;
    border: 1px solid #183879;
    padding: 4px 12px;
}

.onboard-overview .line-chart {
    width: 650px;
    padding-left: 50px;
    padding-top: 20px;
}

.onboard-overview .suspected-wallet {
    border: 1px solid #E1E1E1;
    border-radius: 8px;
    padding: 10px;
}

.onboard-overview .suspected-wallet .header {
    display: flex;
    align-items: center;
}

.onboard-overview .suspected-wallet .search {
    margin-left: auto;
    margin-top: 0;
    padding: 0;
}

.onboard-overview .suspected-wallet input {
    padding: 5px;
}

.onboard-overview .suspected-wallet .fa-search {
    top: 10px;
}`, "",{"version":3,"sources":["webpack://./src/view/reporting-dashboard/onboarding/Overview.css"],"names":[],"mappings":"AAAA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,iBAAiB;IACjB,oBAAoB;IACpB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,SAAS;AACb","sourcesContent":[".onboard-overview {\n    color: #203562;\n}\n\n.onboard-overview .agent-summary {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    /* color: #152C5B; */\n    padding-top: 30px;\n    padding-bottom: 10px;\n    border-radius: 8px;\n}\n\n.onboard-overview .agent-summary h1 {\n    font-size: 14px;\n    font-weight: 400;\n    margin-bottom: 10px;\n}\n\n.onboard-overview .agent-summary p {\n    font-size: 16px;\n    font-weight: 600;\n}\n\n.onboard-overview .total {\n    background-color: #E8F2FF;\n    border: 2px solid #5478A3;\n}\n\n.onboard-overview .active-agent {\n    background-color: #F5F5F5;\n    border: 2px solid #01C6B8;\n}\n\n.onboard-overview .inactive-agent {\n    background-color: #F5F5F5;\n    border: 2px solid #0F344A;\n}\n\n.onboard-overview .invalid-wallet {\n    background-color: #F5F5F5;\n    border: 2px solid #7E7E7E;\n}\n\n.onboard-overview .not-in-use {\n    background-color: #7B16040D;\n    border: 2px solid #7B1603;\n}\n\n.onboard-overview .chart-representation {\n    background-color: #FCFCFC;\n    padding: 10px;\n}\n\n.onboard-overview .activity-chart {\n    display: flex;\n}\n\n.onboard-overview .header h2, .suspected-wallet h2 {\n    font-size: 14px;\n    font-weight: 100;\n    margin-top: 8px;\n}\n\n.onboard-overview select {\n    margin-left: auto;\n    background-color: #F2F2F2;\n    border-radius: 8px;\n    border: 1px solid #183879;\n    padding: 4px 12px;\n}\n\n.onboard-overview .line-chart {\n    width: 650px;\n    padding-left: 50px;\n    padding-top: 20px;\n}\n\n.onboard-overview .suspected-wallet {\n    border: 1px solid #E1E1E1;\n    border-radius: 8px;\n    padding: 10px;\n}\n\n.onboard-overview .suspected-wallet .header {\n    display: flex;\n    align-items: center;\n}\n\n.onboard-overview .suspected-wallet .search {\n    margin-left: auto;\n    margin-top: 0;\n    padding: 0;\n}\n\n.onboard-overview .suspected-wallet input {\n    padding: 5px;\n}\n\n.onboard-overview .suspected-wallet .fa-search {\n    top: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
